import { type HTMLAttributes, forwardRef } from "react";

type Props = HTMLAttributes<HTMLDivElement> & {
  // false にすると内側パディングを付けない (ヘッダ/ボディを自前で組むとき)
  padded?: boolean;
};

// UI キットの基本サーフェス。角丸は rounded-xl に統一 (#137)。
// 既存のアドホックな "rounded-lg/2xl + bg-white + border-slate-200 + shadow" を集約する。
//   <Card>...</Card>                     … パディング付き
//   <Card padded={false}>...</Card>      … 自前レイアウト用
const Card = forwardRef<HTMLDivElement, Props>(({ padded = true, className, children, ...rest }, ref) => {
  return (
    <div
      ref={ref}
      className={
        "rounded-xl border border-slate-200 bg-white shadow-sm" +
        (padded ? " p-6" : "") +
        (className ? ` ${className}` : "")
      }
      {...rest}
    >
      {children}
    </div>
  );
});

Card.displayName = "Card";

export default Card;
